export const API = "https://skytechback.skyangel.com.mx/api";
//export const API="http://localhost:8000/api";
//export const API="http://192.168.0.8:8000/api";
